import React from "react";
import {graphql} from "gatsby";

import SEO from "../components/seo";
import Header from '../components/Header/Header';
import SectionWrapper from '../components/SectionWrapper/SectionWrapper';

const UslugiDodatkowe = ({data}) => {
  const fotovideo = data.FotoVideo.childImageSharp.fluid;
  const florystyka = data.Florystyka.childImageSharp.fluid;
  const pokazyMagii = data.pokazyMagii.childImageSharp.fluid;
  const pokazyBarmanskie = data.pokazybarmanskie.childImageSharp.fluid;
  const redheels = data.Redheels.childImageSharp.fluid;
  const bglink = data.dodatkoweBg.childImageSharp.fluid;

  const titleText = "Usługi dodatkowe";
  const paragraphText = "Proponujemy utalentowanych animatorów oraz profesjonalistów z zakresu dekoracji weselnej oraz obsługi weselnych fotografów i filmowców";

  const content = [
    {
      title: "Red Heels",
      text: "Zaprzyjaźniony zespół dynamicznie grających skrzypaczek. Popularność zdobyły jako finalistki programu Mam Talent. Dziewczyny grają najnowsze hity popowe, rockowe i techno w interpretacji na klasyczne instrumenty. Piękna oprawa dźwiękowa, taniec oraz animacja wspólnej zabawy zrobią wrażenie na każdym gościu weselnym",
      image: redheels,
      alt: "Red Heels",
      link: "https://vimeo.com/287640241",
      target: "yes"
    },
    {
      title: "Obsługa foto-video", 
      text: "Szukają Panstwo utalentowanego fotografa? Zapraszamy do współpracy. Ocenimy Państwa oczekiwania i zaproponujemy odpowiednich rofesjonalistów reprezentująych interesująćy Państwa styl wykonywania zdjęć. Posiadamy kontakty do fotografów w całym kraju. Napisz i zapytaj nas o szczegóły",
      image: fotovideo,
      alt: "Obsługa foto-video"
    },
    {
      title: "Obsługa dekoratorska/florystyka", 
      text: "Piękna oprawa wesela to podstawa wspaniałych wspomnień. Przez lata doświadczenia spotkaliśmy na naszej drodze ogromną ilość artystów specjalizujących się w budowaniu dekoracji oraz tworzeniu bukietów i aranżacji na uroczystośći weselne. Państwo młodzi wiedzą czego chcą, ale nie wiedzą jak znaleźc odpowiedniego profesjonalistę? Napisz do nas, a nasi doradcy pomogą znaleźc Państwu odpowiedniego dekoratora weselnego",
      image: florystyka,
      alt: "Obsługa dekoratorska/florystyka"
    },
    {
      title: "Pokazy Magii", text: "Piękna oprawa wesela to podstawa wspaniałych wspomnień. Przez lata doświadczenia spotkaliśmy na naszej drodze ogromną ilość artystów specjalizujących się w budowaniu dekoracji oraz tworzeniu bukietów i aranżacji na uroczystośći weselne. Państwo młodzi wiedzą czego chcą, ale nie wiedzą jak znaleźc odpowiedniego profesjonalistę? Napisz do nas, a nasi doradcy pomogą znaleźc Państwu odpowiedniego dekoratora weselnego",
      image: pokazyMagii,
      alt: "Pokazy Magii"
    },
    {
      title: "Pokazy Barmańskie", text: "Tak, królem polskich wesel jest tradycyjne 40%. Jednak, jeśli szukają Państwo rozwiązania łączącego zabawę, pokaz oraz dobre drinki prosimy o kontakt. Jak często się Państwu zdarza pić mikstury wykonane przez mistrzów świata pokazów barmańskich? Pokaz na weselu podniesie emocje do maksimum, a smak wykonanych przez naszych barmanów drinków zapewni imprezowy luz i niecodzienne wrażenia smakowe!",
      image: pokazyBarmanskie,
      alt: "Pokazy Barmańskie",
      link: "https://vimeo.com/286951403",
      target: "yes"
    },
    
  ];

  return (
    <>
      <SEO title="Usługi na wesele"/>
      <Header link={bglink}/>
      <SectionWrapper content={content} title={titleText} text={paragraphText} resize="yes"/> 
    </>
  )
};

export const query = graphql`
  {
    Redheels: file(name: {eq: "Redheels"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    FotoVideo: file(name: {eq: "fotovideo"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    Florystyka: file(name: {eq: "Obsluga_dekor"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    pokazyMagii: file(name: {eq: "pokazymagii"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    pokazybarmanskie: file(name: {eq: "pokazybarmanskie1"}) {
      childImageSharp {
        fluid(quality: 90) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    dodatkoweBg: file(name: {eq: "dodatkowe_bg"}) {
      childImageSharp {
        fluid(quality: 100, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`;

export default UslugiDodatkowe